//@flow

import type {Action} from '../actions/actions';
import * as actions from '../actions/actions';
import type {Schedule, State} from '../store';

const defaultSchedule: Schedule = {
  displayAll: false,
};

let initialSchedule = defaultSchedule;

/**
 * These events affect the video player. When the user changes season or special, the
 * player will update to show the associated videos.
 *
 * @param state
 * @param action
 * @returns {Schedule}
 */
export default function schedule(state: Schedule = initialSchedule, action: Action): Schedule {

  switch (action.type) {

    case actions.CLICK_SHOW_ALL_AIRDATES:
      return Object.assign(
        {},
        state,
        { displayAll: action.payload }
      );

    default:
      return state;
  }

}
